var DB_ProductMediaGallery = {
  init:function(){

    var _swiper_main_container = document.querySelector(".DB-product-gallery .DB-product-gallery--viewer.swiper-container");

      var _swiper_nav_container = document.querySelector(".DB-product-gallery .DB-product-gallery--nav.swiper-container");

      var swiper_nav = new Swiper(_swiper_nav_container, {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 10,
          loop: true,
          watchSlidesProgress: true,
          breakpoints: {
            1200: {
              spaceBetween:15
            }
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }
        });
        var swiper_main = new Swiper(_swiper_main_container, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
          effect:"creative",
          thumbs: {
            swiper: swiper_nav,
          },
          creativeEffect: {
            prev: {
              shadow: false,
              opacity:0,
              translate: [0, 0, -100],
            },
            next: {
              shadow:false,
              opacity:0,
              translate: [0, 0, 100],
            },
          },
        });

        // Make swiper instance globally accessible
        window.DB_ProductGallerySwiper = swiper_main;


        document.querySelectorAll(".DB-product-gallery .DB-product-gallery--nav .swiper-slide").forEach(function(slide, i){
          slide.addEventListener("click", function(){
            /*DB_ProductMediaGallery.change_image(i);*/
          })
        });

        document.querySelectorAll(".DB-product-gallery .product-media__video-player").forEach(function(video_container, i){
          video_container.addEventListener("click", function(){
            var _src = video_container.getAttribute("data-src");
            var _type = video_container.getAttribute("data-type");

            var _html_video = "<video autoplay muted playsinline controls width='100%'>";
            _html_video += "<source src='" + _src + "' type='"+ _type + "'/>";
            _html_video += "</video>";
            document.querySelector(".video_player__modal .video-container").innerHTML = _html_video;

            setTimeout(function(){
              document.querySelector(".video_player__modal").classList.add("open");
              document.querySelector(".video_player__modal video").play();
              DB_ProductMediaGallery.resize();
            }, 200);
          })
        });
        document.querySelector(".video_player__modal .shadow").addEventListener("click", function(){
          document.querySelector(".video_player__modal").classList.remove("open");
          document.querySelector(".video_player__modal video").pause();
        });

        window.addEventListener("resize", function(){
          DB_ProductMediaGallery.resize();
        });
        DB_ProductMediaGallery.resize();
  },
  resize:function(){
    var _h = document.querySelector(".video_player__modal .video-container").offsetHeight;

    if(_h > (window.innerHeight - 200)){
      // CALAGE SUR LA HAUTEUR
      document.querySelector(".video_player__modal .video-container").style.height = (window.innerHeight - 200) + "px";
      document.querySelector(".video_player__modal .video-container").style.width = ((window.innerHeight - 200) * (16/9)) - 25 + "px";
    }else{
      document.querySelector(".video_player__modal .video-container").style.height = "auto";
      document.querySelector(".video_player__modal .video-container").style.width = "100%";
    }
  },
  change_image:function(id){

    document.querySelectorAll(".DB-product-gallery--viewer .media-container").forEach(function(img, i){
      if(i == id){
        img.classList.add("selected");
      }else{
        img.classList.remove("selected");
      }
    });


    document.querySelectorAll(".DB-product-gallery .DB-product-gallery--nav .swiper-slide").forEach(function(slide, i){
      if(i == id){
        slide.classList.add("selected");
      }else{
        slide.classList.remove("selected");
      }
    });
  },
  swipeToVariant:function(variantId){
    if (!window.DB_ProductGallerySwiper) return;
    
    // Find the nav thumbnail with the matching variant ID first
    const navThumbnails = document.querySelectorAll('.DB-product-gallery--nav .swiper-slide img[data-variant-id="' + variantId + '"]');
    
    if (navThumbnails.length > 0) {
      // Get the index of the thumbnail's parent slide
      const thumbnailSlide = navThumbnails[0].closest('.swiper-slide');
      const allNavSlides = document.querySelectorAll('.DB-product-gallery--nav .swiper-slide');
      
      let targetIndex = -1;
      allNavSlides.forEach((slide, index) => {
        if (slide === thumbnailSlide) {
          targetIndex = index;
        }
      });
      
      // If we found a matching slide, swipe to it
      if (targetIndex >= 0) {
        window.DB_ProductGallerySwiper.slideTo(targetIndex);
        return;
      }
    }
    
    // Fallback: Check main viewer slides
    const viewerSlides = document.querySelectorAll('.DB-product-gallery--viewer .swiper-slide');
    let targetIndex = -1;
    
    viewerSlides.forEach((slide, index) => {
      const mediaWithVariant = slide.querySelector('.product__media[data-variant-id="' + variantId + '"]');
      if (mediaWithVariant) {
        targetIndex = index;
      }
    });
    
    // If we found a matching slide, swipe to it
    if (targetIndex >= 0) {
      window.DB_ProductGallerySwiper.slideTo(targetIndex);
    }
  }
}

window.addEventListener("load", function(){
  if(document.querySelectorAll(".DB-product-gallery").length > 0){
      DB_ProductMediaGallery.init();
      
      // Make swipeToVariant globally accessible
      window.swipeToVariant = DB_ProductMediaGallery.swipeToVariant;
  }
})